export const skinCustom = {
  lightComponents: {
    body: '#ECEFF1',
    gradient: {
      gradientDefault1: '#ec3137',
      gradientDefault2: '#b1353e',
    },
  },
  darkComponents: {
    body: '#263238',
    gradient: {
      gradientDefault1: '#172260',
      gradientDefault2: '#000000',
    },
  },
}

export const image = {
  principal: 'https://senhadigitalmacapa.com.br/image-bank/logobranca.png',
  favicon: 'https://senhadigitalmacapa.com.br/image-bank/logo_cadeado.png',
}

export const seo = {
  titulo: 'Senha Digital Macapá',
  email: 'suporte@senhadigital.com.br',
  palavrasChave:
    'Certificado Digital, Cnpj a1, Cpf a1, emitir certificado, certificado Macapá',
  descricao:
    'Empresa líder em Certificação Digital, oferecendo soluções seguras e confiáveis para empresas e indivíduos, com ampla experiência no mercado.',
  descricaoPWA:
    'Certificados digitais são identidades eletrônicas seguras usadas para autenticar usuários, proteger informações e realizar transações online com segurança.',
}

export const header = {
  empresa: false,
  solucoes: false,
  contato: true,
  trabalheConosco: false,
  duvidasSuporte: true,
  parcerias: false,
  darkMode: false,
  contaLogin: true,
}

export const contentHome = {
  sispass: false,
  produtorRural: false,
  modalidadesCertificado: false,
}

export const footer = {
  is0800: false,
  telefone: '96 99173-2599',
  whatsapp: '96 99173-2599',
  botaoRenocao: '96991732599',
  comercial: '96991732599',
  botaoWhatsapp: '96991732599',
  number0800: '0800 600 2710',
  cidadeuf: 'Macapá/AP',
  cidade: 'Macapá',
  bairro: 'Centro',
  titulo: 'Certificado Digital em Macapá',
  rua: 'Av. Padre Júlio Maria Lombaerd',
  numero: '937',
  complemento: 'DENTRO DA LOJA DR SHAPE',
  cep: '68900-030',
  cnpj: '',
  messageContador: 'Olá, tenho interesse em ser Parceiro Indicador.',
  messageRevenda: 'Olá, tenho interesse em revender Certificados Digitais',
  messageAgendamento: 'Olá, gostaria de agendar a emissão do meu Certificado',
  messageRenovacao: 'Olá, gostaria de renovar meu Certificado Digital',
  messageRenovacaoSispass:
    'Olá, gostaria de renovar meu Certificado Digital Sispass',
  messageConhecaNossasSolucoes: 'Olá, gostaria de conhecer as soluções',
}

export const redes = {
  facebook:
    'https://www.facebook.com/p/Senha-Digital-Macap%C3%A1-100052728077936/',
  instagram: 'https://www.instagram.com/senha.digital/?g=5',
  linkedin: '',
}

export const digisac = {
  id: 'df7a6a14-269a-46ba-a874-33c45e74badf',
  status: false,
}

export const ratings = [
  {
    id: 1,
    descricao: 'Suporte e Atendimento excelentes!',
    author: 'Leonardo Lopes',
    ratingvalue: 5,
  },
  {
    id: 2,
    descricao:
      'Atendimento excelente. Super ágil, prático e simplificado! Ótima organização da equipe.',
    author: 'Tháliton Morais',
    ratingvalue: 5,
  },
  {
    id: 3,
    descricao: 'Atendimento do Suporte Técnico nota 10!.',
    author: 'Felipe Mourão',
    ratingvalue: 5,
  },
]
